import React from 'react';

/**
 * Convenience wrapper around any icon component (we standardize on Feather
 * — `react-icons/fi` — for new code). Centralizes size + tone so consumers
 * don't repeat `className="w-4 h-4 text-success"` everywhere.
 *
 *   import { FiCheck } from 'react-icons/fi';
 *   <Icon as={FiCheck} tone="success" />
 *
 * Tone tokens map to design tokens (text-fg, text-fg-muted, text-primary,
 * text-success, etc.) so dark-mode flips automatically.
 */
const SIZES = {
  xs: 'w-3 h-3',
  sm: 'w-3.5 h-3.5',
  md: 'w-4 h-4',
  lg: 'w-5 h-5',
  xl: 'w-6 h-6',
  '2xl': 'w-8 h-8',
};

const TONES = {
  default: 'text-fg',
  muted: 'text-fg-muted',
  subtle: 'text-fg-subtle',
  primary: 'text-primary',
  secondary: 'text-secondary',
  success: 'text-success',
  warning: 'text-warning',
  error: 'text-error',
  inherit: '',
};

export default function Icon({
  as: As,
  size = 'md',
  tone = 'default',
  className = '',
  ...rest
}) {
  if (!As) return null;
  const classes = [
    SIZES[size] ?? SIZES.md,
    TONES[tone] ?? TONES.default,
    'shrink-0',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return <As className={classes} aria-hidden="true" {...rest} />;
}
